import { TournamentMatchGameActivityType } from '@okletsplay/core';
import React, { FC, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ModalName, Route } from 'app/enums';
import { modalsReducers } from 'app/store/modal/slice';
import { tournamentActivitySelector } from '../../store/selectors';
import { CheckinTournamentGame } from '../CheckinTournamentGame';
import { NewTournamentGame } from '../NewTournamentGame';
import { NextTournamentGame } from '../NextTournamentGame';
import { WaitingNextGame } from '../WaitingNextGame';

export const TournamentGameActivity: FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tournamentActivity = useSelector(tournamentActivitySelector.activity);

  const type = useMemo(() => tournamentActivity.activity?.type, [tournamentActivity]);

  const openTournament = useCallback(() => {
    if (!tournamentActivity.tournament?.id) {
      return;
    }

    dispatch(modalsReducers.closeModal(ModalName.FullScreenBracket));
    navigate(Route.TournamentOverview.replace(':id', tournamentActivity.tournament.id));
  }, [dispatch, tournamentActivity, navigate]);

  return useMemo(() => {
    switch (type) {
      case TournamentMatchGameActivityType.GameStart:
        return <NewTournamentGame onTournamentClick={openTournament} />;
      case TournamentMatchGameActivityType.NextGameStart:
        return <NextTournamentGame onTournamentClick={openTournament} />;
      case TournamentMatchGameActivityType.Checkin:
        return <CheckinTournamentGame onTournamentClick={openTournament} />;
      case TournamentMatchGameActivityType.WaitingNextGame:
        return <WaitingNextGame onTournamentClick={openTournament} />;
      default:
        return null;
    }
  }, [type, openTournament]);
};
